import { useState, useEffect } from "react";

export const mediaQueryListSet: Set<MediaQueryList> = new Set();

export const useMediaQuery = (query: string) => {
  const [matches, setMatches] = useState(window.matchMedia(query).matches);

  useEffect(() => {
    const mediaQueryList = window.matchMedia(query);
    setMatches(mediaQueryList.matches);

    const listener = (e: MediaQueryListEvent) => setMatches(e.matches);
    mediaQueryList.addEventListener("change", listener);

    mediaQueryListSet.add(mediaQueryList);

    return () => {
      mediaQueryList.removeEventListener("change", listener);
      mediaQueryListSet.delete(mediaQueryList);
    };
  }, [query]);

  return matches;
};
